<template>
    <div class="unconnect-complete-page">
        <div class="complete-image"></div>
        <p class="complete-title">Smartwatch ingenomen</p>
        <p class="complete-text">
            U heeft smartwatch
            <b>{{ walkToFinish.smartwatch.smartwatchName }}</b> ingenomen van client <b>{{ walkToFinish.client.initials }}</b>
        </p>
        <p>Miles cliëntrapport is aangemaakt en opgeslagen in de map Downloads</p>
        <button-component @click.native="goHome">Doorgaan</button-component>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ButtonComponent from '../components/button.component.vue';
    import { RouteName } from '../utils/enums';
    import { toSimpleDateFormat } from '../utils/filters';
    import ExportService from "../services/export.service";
    import { Walk } from "../domain/walk";

    const exportService = new ExportService();

    export default {
        name: 'unconnect-complete-page',
        components: {
            ButtonComponent,
        },
        data() {
            return {
                walkToFinish: Walk
            }
        },
        created() {
            this.walkToFinish = this.$store.getters.getWalkToFinish;
            this.downloadReport(this.walkToFinish);
        },
        computed: {
            ...mapGetters(['getWalkToFinish'])
        },
        methods: {
            goHome: function () {
                this.$router.push({name: RouteName.HOME});
            },
            downloadReport: function () {
                exportService.exportPdfReport(this.walkToFinish);
            }
        }
    };
</script>
<style scoped lang="scss">
    .unconnect-complete-page {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .complete-title {
            margin-bottom: 14px;
        }

        p {
            font-size: 16px;
        }
    }

    .complete-image {
        width: 95px;
        height: 120px;
        background-image: url('../assets/icons/watch-large-complete.svg');
        margin-bottom: 64px;
        margin-top: -60px;
    }

    .box {
        width: 100%;
        margin-bottom: 2rem;

        @include desktop {
            background-color: $white;
            padding: 1rem;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 0.25rem;
        }

        h4 {
            font-weight: bold;
            margin-bottom: 1rem;
            color: $gray-darkest;
        }

        p {
            color: $gray-dark;
        }
    }
</style>
